import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';

export interface Signature {
  Element: HTMLDivElement;
  Blocks: {
    header: [];
    col1: [];
    col2?: [];
  };
}

// This component factorizes a responsive display
//- displays as a flex-col on mobile
//- displays as a grid with 2 or 3 columns on desktop
export default class WrFormRowComponent extends Component<Signature> {
  @tracked needsColspan = false;

  checkEmpty = modifier(element => {
    if (element.childNodes.length == 0) this.needsColspan = true;
  });

  <template>
    <div
      class='text-p1 mb-6 flex flex-col sm:mb-0 sm:grid sm:grid-cols-3 sm:gap-6 [&:first-child>*]:sm:rounded-tr [&:last-child>*]:sm:rounded-br [&:last-child]:mb-2 [&>*:empty]:hidden [&>*]:px-0 [&>*]:sm:py-6'
      ...attributes
    >
      <div
        class='sm:to-grey-light text-purple sm:bg-gradient-to-r sm:from-white sm:text-right [&]:sm:px-4'
      >{{yield to='header'}}</div>
      <div class={{if this.needsColspan 'col-span-2'}}>{{yield to='col1'}}</div>

      {{! Make sure keep this a ONELINER to avoid additional whitespace being added }}
      <div {{this.checkEmpty}}>{{yield to='col2'}}</div>
    </div>
  </template>
}
